import React from 'react';
import { connect } from 'react-redux';
import {
  Table,
} from 'semantic-ui-react';

const TableRow = (props) => {
  if (props.value == '') {
    return null;
  }

  return (
    <Table.Row>
      <Table.Cell
        content={props.label.replace(/_/g, ' ')}
        style={{
          textTransform: 'capitalize'
        }}
        width={5}
      />
      <Table.Cell content={props.value ? props.value : '-'} />
    </Table.Row>
  )
};

function RenterInfo(props) {
  const {
    coRenter,
    renter,
  } = props;

  const rows = [
    'address_1',
    'address_2',
    'city',
    'state',
    'zip',
    'email',
    'home_phone',
    'drivers_license',
    // 'birthdate',
    'employer_name',
    'employer_phone',
    'employer_address_1',
    'employer_address_2',
    'employer_city',
    'employer_state',
    'employer_zip',
  ];

  const refRows = [
    'first_name',
    'last_name',
    'relationship',
    'phone',
    'email',
  ];

  return (
    <div>
      <h3>{renter.first_name} {renter.last_name} (Renter)</h3>
      <Table compact="very" color="blue" celled>
        <Table.Body>
          {
            rows.map((row, i) => (
              <TableRow
                key={i}
                label={row}
                value={renter[row]}
              />
            ))
          }
          {
            renter.references.map((ref, refIdx) => (
              refRows.map((row, i) => (
                <TableRow
                  key={i}
                  label={`Reference ${refIdx + 1} ${row}`}
                  value={ref[row]}
                />
              ))
            ))
          }
        </Table.Body>
      </Table>
      {
        coRenter &&
          <React.Fragment>
            <h3>{coRenter.first_name} {coRenter.last_name} (Co-Renter)</h3>
            <Table compact="very" color="blue" celled>
              <Table.Body>
                {
                  rows.map((row, i) => (
                    <TableRow
                      key={i}
                      label={row}
                      value={coRenter[row]}
                    />
                  ))
                }
                {
                  coRenter.references.map((ref, refIdx) => (
                    refRows.map((row, i) => (
                      <TableRow
                        key={i}
                        label={`Reference ${refIdx + 1} ${row}`}
                        value={ref[row]}
                      />
                    ))
                  ))
                }
              </Table.Body>
            </Table>
          </React.Fragment>
      }
    </div>
  );
}

function mapStateToProps(state) {
  return {
    coRenter: state.coRenter,
    renter: state.renter,
  }
}

export default connect(mapStateToProps)(RenterInfo);
